/* eslint-disable eqeqeq */
import React, { useState, useEffect } from 'react';
import { useHistory } from "react-router-dom";
import { Pages } from '../../../utils/Utils';
import { PlannerApi } from '../../../api/PlannerApi';
import { ScrollMenu, VisibilityContext } from 'react-horizontal-scrolling-menu';
import left_arrow from '../../../img/experts/left_arrow.svg'
import PlannedPlannerItem from '../../planner/list_items/PlannedPlannerItem';
import { getIsDesktop } from '../../../utils/Utils';
import moment from 'moment'
import ProfileGroupCalls from '../../profile/custom_views/ProfileGroupCalls';

function PlannersList(props) {
    const [planners, setPlanners] = useState([])
    const history = useHistory()
    useEffect(() => {
        PlannerApi.getMyPlanner((responseData) => {
            console.log("getMyPlanner result = ", responseData.result)
            getGroupCalls(responseData.result)
        }, (responseData) => {
        })
    }, [])
    const getGroupCalls = (planners) => {
        PlannerApi.getMySozvonByLink((responseData) => {
            var result = [...planners]
            result.push(...responseData.result)
            result.sort(function(a,b){
                return moment(a.sozvon_date).utc().local().toDate() - moment(b.sozvon_date).utc().local().toDate();
            })
            console.log("getGroupCalls result = ", result)
            setPlanners(result)
        }, (responseData) => {

        })
        
    }
   
    return (
            // <div className="planner_list_bg">
            //     {/* <p onClick={() => history.push(Pages.planned_planner)} style={isDesktop ? {} : {marginTop : '12px'}} className="experts_title_section planner_list_title_desktop hover">Запланированные созвоны</p> */}
            //     <p onClick={() => history.push(Pages.planned_planner)}className="lk_planners_title hover">Запланированные видеовстречи</p>
            //     {planners.length > 0 && <div className="carousel_mobile">{getInnerCorousel()}</div>}
            //     {planners.length > 0 && <div style={{margin : '0 0 0 ' + (isDesktop ? '0' :  '-16px')}} className="popular_horizontal_cont planner_list_corousel">{getInnerCorousel()}</div>}
            //     {planners.length == 0 && getEmpty()}
            //     {/* {getEmpty()} */}
            // </div>
           <ProfileGroupCalls isMyCalls style={{maxWidth : 'none', margin : '12px 0 0 0'}} planners={planners}/>
    );
    
}
function Card({ slide, itemId, index }){
    const visibility = React.useContext(VisibilityContext);
    const visible = visibility.isItemVisible(itemId);
    const isDesktop = getIsDesktop()
    return (
        <div style={index == 0 ? {marginLeft : isDesktop ? '1px' : '16px'} : (index == 3 && isDesktop) ? {} : {}}>
            <PlannedPlannerItem isFromMainScreen item={slide}/>
        </div>
    );
}
function LeftArrow() {
    const { isFirstItemVisible, scrollPrev } = React.useContext(VisibilityContext);
    return (
      <img alt="" style={isFirstItemVisible ? {opacity : 0, pointerEvents : 'none'} : {}} className="experts_arrow_scroll planner_arrow_scroll_left hover" src={left_arrow} disabled={isFirstItemVisible} onClick={() => scrollPrev()}></img>
    ); 
}
  
function RightArrow() {
    const { isLastItemVisible, scrollNext } = React.useContext(VisibilityContext);
    return (
        <img alt="" style={isLastItemVisible ? {opacity : 0, pointerEvents : 'none'} : {}} className="experts_arrow_scroll experts_arrow_right planner_arrow_scroll hover" src={left_arrow} disabled={isLastItemVisible} onClick={() => scrollNext()}></img>
    );
}
export default PlannersList;
